<script setup>
import IndexNavbar from "@/components/Navbars/IndexNavbar.vue";
import FooterComponent from "@/components/Footers/Footer.vue";
</script>
<template>
  <div>
    <index-navbar/>
    <section
        class="header relative pt-16 items-center flex h-screen max-h-860-px"
    >
      <div class="container mx-auto items-center flex flex-wrap">
        <div class="w-full md:w-8/12 lg:w-6/12 xl:w-6/12 px-4">
          <div class="pt-32 sm:pt-0">
            <h1 class="font-semibold text-4xl text-blueGray-600">
              PVGDB2.0
            </h1>
            <p class="mt-4 text-lg leading-relaxed text-blueGray-500" style="text-align: justify;font-size:18px">
              PVGDB2.0 database was established to host bulk and single-cell RNA-seq resources of Litopenaeus
              vannamei.<br>
              376 bulk RNA-seq datasets spanning diverse biological contexts of L. vannamei were integrated. Functional
              annotations were further expanded through sequence similarity and co-expression network analysis. A
              comprehensive single-cell atlas encompassing 56,851 cells from 6 major tissues was generated, defining 16
              distinct cell types. Integration with bulk RNA-seq profiles delineated the gene expression landscape,
              revealing molecular signatures unique to individual cell populations.
            </p>
          </div>
        </div>
        <div class="w-full lg:w-6/12 xl:w-6/12 px-4">
          <img src="@/assets/pic/introduce.png" style="width: 100%">
        </div>
      </div>

    </section>

    <footer-component/>
  </div>
</template>
